import { FadeUp, SectionHeading } from "./Reveal";

const QUOTES = [
  {
    quote: "ETMB took our project from a sketch on a napkin to a home that stops traffic. One team, one contract, zero drama.",
    author: "Jay Riley",
    role: "Riley Residence",
  },
  {
    quote: "The rare firm that draws beautifully and builds precisely. Budget met, schedule kept, punch list nearly empty.",
    author: "Home Owner",
    role: "663 Emerson St",
  },
];

export const Testimonials = () => (
  <section className="px-6 md:px-12 py-28 md:py-40 bg-surface border-y border-white/10" data-testid="testimonials-section">
    <SectionHeading index="Words From Clients" title="In Their Words" testId="testimonials-heading" />
    <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24">
      {QUOTES.map((q, i) => (
        <FadeUp key={q.author} delay={i * 0.15}>
          <figure data-testid={`testimonial-${i + 1}`}>
            <span className="font-display text-8xl leading-none text-white/10 select-none">&ldquo;</span>
            <blockquote className="text-xl md:text-2xl font-light leading-relaxed -mt-6">
              {q.quote}
            </blockquote>
            <figcaption className="mt-8 text-xs tracking-[0.3em] uppercase text-ash">
              {q.author} — <span className="text-paper">{q.role}</span>
            </figcaption>
          </figure>
        </FadeUp>
      ))}
    </div>
  </section>
);
